import { Component, Input } from '@angular/core';
import { url, Comment } from '../container';
import { FirestoreService } from '../firestore-service.service';
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { getStorage, ref as refStorage, getDownloadURL } from "firebase/storage"
import { SharedServiceService } from '../shared-service.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmingDialogComponent } from '../confirming-dialog/confirming-dialog.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AttachedfilesComponent } from '../attachedfiles/attachedfiles.component';
import { AddcommentComponent } from '../addcomment/addcomment.component';

@Component({
    selector: 'app-showcomment',
    templateUrl: './showcomment.component.html',
    styleUrls: ['./showcomment.component.scss'],
    standalone: true,
    imports: [
      CommonModule, 
      FormsModule,
      AttachedfilesComponent,
      AddcommentComponent,
      ConfirmingDialogComponent
    ]
})
export class ShowcommentComponent {
  @Input() organizationKey: string = "";
  @Input() projectKey: string = "";
  @Input() projectName: string = "";
  @Input() postKey: string = "";
  @Input() userId: string = "";
  @Input() authorKey: string = "";
  @Input() authorName: string = "";
  @Input() userDisplayName: string = "";
  @Input() dateOfCreation: Date = new Date();
  @Input() dateOfUpdate: Date = new Date();
  @Input() formattedDate: string = "";
  @Input() isDeleted: boolean = false;
  @Input() channelKey: string = ""
  @Input() channelName: string = "";
  @Input() channelPath: string = "";
  @Input() imageURLs: url[] = []
  @Input() commentKey: string = "";
  @Input() pathSegments: string[] = [];
  @Input() commentContent: string = "";
  @Input() contentType: string = "";
  @Input() userImageURL = ""
  @Input() embeddingModel = ""
  //@Input() comment: Comment = {} as Comment
  editedCommentKey: string = "" // if user clicked comment to edit the variable contains its key
  //isAddCommentEditorPresent: boolean = true
  comments: Comment[] = [];
  newPathSegments: string[] = [];
  //isPathSegmentCreated: boolean = false

  constructor(private firestoreDb: FirestoreService, public service: SharedServiceService, public dialog: MatDialog) {
    /*translate.addLangs(['en', 'fr', 'pl', 'es']);
    translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang!.match(/en|fr|pl|es/) ? browserLang! : 'en');*/
  }

  ngOnInit() { }

  ngAfterViewInit() { }

  ngAfterContentInit() {
    this.newPathSegments = Object.assign([], this.pathSegments);
    this.newPathSegments.push(this.commentKey)
    this.newPathSegments.push("comments")
    this.startListeningToComments()
  }

  async removeImage(commentKey: string, image: url, index: number) {
    const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
      data: {"content": "Are you sure to remove this file?", "onlyCloseButton": false}
    });
    dialogConfirmingRef.afterClosed().subscribe(async (r) => {
      if (r == true) {
        await this.firestoreDb.removeImage(this.organizationKey, commentKey, image.imageKey, image.url)
        this.imageURLs.splice(index, 1)
      }
    })
  }

  async removeComment() {
    const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
      data: {"content": "Are you sure to remove this comment?", "onlyCloseButton": false}
    });
    dialogConfirmingRef.afterClosed().subscribe(async (r) => {
      if (r == true) {
        await this.firestoreDb.removeComment(this.organizationKey, this.channelKey, this.contentType, this.projectKey, this.newPathSegments)
        await this.firestoreDb.incrementCommentCount(this.organizationKey, this.channelKey, this.projectKey, -1)
      }
    })
  }

  editComment(commentKey: string) {
    //this.isAddCommentEditorPresent = false
    this.editedCommentKey = commentKey
    this.service.editedCommentKey = commentKey
    //this.startListeningToImages(this.channelKey, commentKey)
  }

  async addCommentToComment() {
    let newKey = await this.firestoreDb.getNewCommentId(this.organizationKey, this.channelKey)
    await this.firestoreDb.addCommentToComment(this.organizationKey, this.userDisplayName, this.userId, this.channelName, this.channelPath, this.channelKey, this.newPathSegments, newKey, this.contentType, this.projectKey)
    //this.imageURLs.splice(0, this.imageURLs.length)
    //this.commentKey = this.firestoreDb.getNewCommentId(this.channelKey)
    //this.startListeningToImages(this.channelKey, newKey)
    //this.isAddCommentEditorPresent = false
    this.service.editedCommentKey = newKey
    //this.notify.emit({"commentKey": "", "isAddEditorPresent": this.isAddCommentEditorPresent})
  }

  startListeningToComments() {  
    const db = this.firestoreDb.getApps()
    const queryConstraints = []
    queryConstraints.push(where("isEmpty", "==", false))
    queryConstraints.push(where("isDeleted", "==", false))
    const q = query(collection(db, "organizations", this.organizationKey, "content", ...this.newPathSegments), ...queryConstraints);
    onSnapshot(q, (snapshot) => {
      this.comments.splice(0, this.comments.length);
      snapshot.forEach((child) => {
        let content: any = child.get("content")
        const dateOfCreation = new Date(child.get("dateOfCreation")) 
        const dateOfUpdate = new Date(child.get("dateOfUpdate")) 
        const formattedDate = dateOfUpdate.toLocaleDateString("pl-PL") + " " + dateOfUpdate.toLocaleTimeString("pl-PL")
        let userId: any = child.get("userId")
        let userName: any = child.get("userName")
        let objectKey: any = child.get("canvasObjectKey")
        let objectType: any = child.get("canvasObjectType")
        const parentCommentKey: any = child.get("parentCommentKey") || "  "
        const userImageURL = child.get("userImageURL")
        let imageURLS: url[] = []
        let isDeleted = (child.get("isDeleted") == true)
        if (isDeleted == true) {
          content = "<p>(comment removed)</p>"
          imageURLS.splice(0, imageURLS.length)
        }
        let commentKey: string = child.id
        this.comments.push({"key": commentKey, "content": content, "dateOfCreation": dateOfCreation, "dateOfUpdate": dateOfUpdate, "formattedDate": formattedDate, "userId": userId, "userName": userName, "imageURLS": imageURLS, "isDeleted": isDeleted, "canvasObjectKey": objectKey, "canvasObjectType": objectType, "userImageURL": userImageURL, "projectKey": this.projectKey, "parentCommentKey": parentCommentKey})
        let commentIndex = this.comments.length-1
        if (isDeleted == false) {
          this.firestoreDb.getImagesForComment(this.channelKey, commentKey, commentIndex).then((urls) => {
            urls.snapshot.forEach(url => {
              const storage = getStorage();
              const imageRef = refStorage(storage, url.get("url"));
              getDownloadURL(imageRef)
                .then((u) => {
                  imageURLS.push({"url": u, "type": url.get("type"), "imageKey": url.id, "coverImageURL": "", "isChecked": false, "isAnalyzed": false}) // tu trzeba dorobić odczytywanie obrazka okładkowego!!!
                  let comInd = this.getCommentByKey(commentKey)
                  if (comInd > -1) {
                    this.comments[comInd].imageURLS = imageURLS
                  }
                })   
            })
          })
        }
      });
      this.comments.sort(function (a, b) {
        return b.dateOfCreation.getTime() - a.dateOfCreation.getTime();
      })
      //this.isLoadingLabelVisible = false
    });
  }

  getCommentByKey(commentKey: string) {
    for (let c = 0; c < this.comments.length; c++) {
      if (this.comments[c].key == commentKey) {
        return c
      }
    }
    return -1
  }

  startListeningToImages(channelKey: string, commentKey: string) {
    const db = this.firestoreDb.getApps()
    const q = query(collection(db, "channels", channelKey, "comments", commentKey, "images"));
    //if (this.unsubscribeImages() != null) {
    //  this.unsubscribeImages()
    //}

    onSnapshot(q, (snapshot) => {
      this.imageURLs.splice(0, this.imageURLs.length);
      snapshot.forEach((child) => {
        let imagePath: any = child.get("url")
        let imageType: string = child.get("type")
        let coverImageURL: string = child.get("coverImageURL")
        let imageKey = child.id
        const storage = getStorage();
        const imageRef = refStorage(storage, imagePath);
        getDownloadURL(imageRef)
          .then((url) => {
            this.imageURLs.push({"url": url, "type": imageType, "imageKey": imageKey, "coverImageURL": coverImageURL, "isChecked": false, "isAnalyzed": false})
          })
      });
    })
  }

}
